import React, { useEffect } from 'react'
import { Modal, Row, Col, App, Button, Space } from 'antd'
import { useState } from 'react'
import classes from './cost.module.css'
import { useDingdanzhichuUpdateQuery, useFKchaosongMutation, useDingdanzhichuZTXGMutation } from '../../store/DianShangYeWuApi'
import StateTag from '../../cpn/StateTag';
import CostNodeCheck from './CostNodeCheck' 
import Asterisk from '../../cpn/Asterisk'
import ReportCheck from '../report/ReportCheck'
import ClientCheck from '../../system/client/ClientCheck'
import DocumentRule from '../../cpn/DocumentRule'
import Icon from '../../cpn/Icon'
import FilePreview from '../../cpn/FilePreview'
import { usePrintModal } from '../../cpn/usePrintModal'
import CostFinanceWithdraw from './CostFinanceWithdraw'
import CostFinanceAmount from './CostFinanceAmount'
import CostFinanceZFLX from './CostFinanceZFLX'
import Copy from '../../cpn/Copy'
import AccountCheck from '../../system/account/AccountCheck'
function CostCheck(props) {
    const yh_qx = props.yh_qx || '';
    const { message } = App.useApp();
    const [openCheck, setOpenCheck] = useState(false)
    const { handlePrint, modalRef } = usePrintModal(openCheck, '付款单')
    const [info, setInfo] = useState({
        ddzc_content: '',
        ddzc_ctime: '',
        ddzc_price: '',
        ddzc_uname: '',
        ddzc_num: '',
        ddzc_type_id: '',
        ddzc_type_name: '',
        ddzc_kh_id: '',
        ddzc_kh_name: '',
        ddzc_amount: '',
        ddzc_date: '',
        ddzc_date_end: '',
        ddzc_bzd_name: '',
        ddzc_bzd_danhao: '',
        ddzc_id: '',
        ddzc_yuedu: '',
        ddzc_state: '',
        ddzc_uid: '',
        ddzc_bzd_id: '',
        ddzc_month: '',
        ddzc_year: '',
        ddzc_state_time: '',
        ddzc_cw_content: '',
        ddzc_zflx: '',
        ddzc_qyyhzh_id: '',
        ddzc_qyyhzh_name: '',
        ddzc_qyyhzh_date: '',
    })
    const { data, isSuccess } = useDingdanzhichuUpdateQuery({ ddzc_id: props.ddzc_id }, { skip: !openCheck, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            setInfo(prev=>({...prev,
                ddzc_content: data.Result.ddzc_content,
                ddzc_ctime: data.Result.ddzc_ctime,
                ddzc_price: data.Result.ddzc_price,
                ddzc_uname: data.Result.ddzc_uname,
                ddzc_num: data.Result.ddzc_num,
                ddzc_type_id: data.Result.ddzc_type_id,
                ddzc_type_name: data.Result.ddzc_type_name,
                ddzc_kh_name: data.Result.ddzc_kh_name,
                ddzc_kh_id: data.Result.ddzc_kh_id,                
                ddzc_amount: data.Result.ddzc_amount,
                ddzc_date: data.Result.ddzc_date,
                ddzc_date_end: data.Result.ddzc_date_end,
                ddzc_bzd_name: data.Result.ddzc_bzd_name,
                ddzc_bzd_danhao: data.Result.ddzc_bzd_danhao,
                ddzc_id: data.Result.ddzc_id,
                ddzc_yuedu: data.Result.ddzc_yuedu,
                ddzc_state: data.Result.ddzc_state,
                ddzc_uid: data.Result.ddzc_uid,
                ddzc_bzd_id: data.Result.ddzc_bzd_id,
                ddzc_month: data.Result.ddzc_month,
                ddzc_year: data.Result.ddzc_year,
                ddzc_state_time: data.Result.ddzc_state_time,
                ddzc_image_file: data.Result.ddzc_image_file,
                ddzc_image_name: data.Result.ddzc_image_name,
                ddzc_bm_name: data.Result.ddzc_bm_name,
                ddzc_bm_id: data.Result.ddzc_bm_id,
                ddzc_khyhzh_name: data.Result.ddzc_khyhzh_name,
                ddzc_khyhzh_id: data.Result.ddzc_khyhzh_id,
                ddzc_cw_content: data.Result.ddzc_cw_content,
                ddzc_zflx: data.Result.ddzc_zflx,
                ddzc_qyyhzh_id: data.Result.ddzc_qyyhzh_id,
                ddzc_qyyhzh_name: data.Result.ddzc_qyyhzh_name,
                ddzc_qyyhzh_date: data.Result.ddzc_qyyhzh_date,
            }))
        }
    }, [data, isSuccess])
    //取消提交
    // const [ztxg] = useJiekuanZTXGMutation()
    // const [isSubmitting, setIsSubmitting] = useState(false)
    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '0.00';
        return `￥${Number(value).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
    
    //抄送
    const [fkChaosong] = useFKchaosongMutation()
    //取消提交
    const [ztxg] = useDingdanzhichuZTXGMutation()   
    const [isSubmitting, setIsSubmitting] = useState(false)
    
    return (
        <>
           <a 
                type='check' 
                onClick={() => { 
                    if(props.ddzc_sp_state==='2' && props.ddzc_sp_jd_name==='抄送'){
                        fkChaosong({
                            'ddzc_sp_id': props.ddzc_sp_id,     //抄送节点id
                            'ddzc_id': props.ddzc_id,
                            'ddzc_sp_yh_id': props.ddzc_sp_yh_id   //抄送人id
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('抄送成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('抄送失败'+res.data.Message)
                            }
                        })
                    }else if(props.ddzc_state === '5' && props.ddzc_uid === props.yh_id){
                        ztxg({
                            ddzc_id:props.ddzc_id,
                            ddzc_state: '6',
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('已读标记成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('已读标记失败'+res.data.Message)
                            }
                        })
                    }else{
                        setOpenCheck(true);  
                    }
                }} 
            >
                {(props.ddzc_sp_state==='2' && props.ddzc_sp_jd_name==='抄送')&&<span style={{color:"red"}}>未读：</span>}
                {(props.ddzc_state==='5' && props.ddzc_uid === props.yh_id && props.listType === 'submitted')&&<span style={{color:"red"}}>未读：</span>}
                {props.ddzc_state==='4'&&<span style={{color:"red"}}>已驳回：</span>}
                {props.ddzc_sp_ddzc_kh_name?props.ddzc_sp_ddzc_kh_name:props.ddzc_kh_name}
            </a>
            <Modal
                open={openCheck}
                onCancel={() => setOpenCheck(false)}
                onOk={() => setOpenCheck(false)}
                width={1330}
                footer={[
                    <Button key="print" type="primary" onClick={handlePrint}>
                        打印
                    </Button>,
                    <Button key="close" onClick={() => setOpenCheck(false)}>
                        关闭
                    </Button>
                ]}
            >
                <div ref={modalRef}>
                <Row style={{width:"1280px"}}>
                    {(info.ddzc_state === '5' || info.ddzc_state==='6') && <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}>
                        <img src={'./img/costFinished.png'} alt="付款单" width={150} height={150}/>
                    </div>} 
                    <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid green',borderLeft:'3px solid green'}}></Col>
                    <Col span={16} className={classes.row_top_middle} style={{color:'green',borderTop:'3px solid green'}}>付款单</Col>
                    <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid green',borderRight:'3px solid green'}}></Col>
                    {/* 第一行 */}
                    <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid green',color:'green'}}>团队名称</Col>
                    <Col span={6}  className={classes.col_top_input} style={info.ddzc_bzd_name ? {} : {padding: '15px'}}>
                        <ReportCheck dsbzd_id={info.ddzc_bzd_id} dsbzd_name={info.ddzc_bzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col>  
                    <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                    <Col span={6}  className={classes.col_top_input}>
                        {info.ddzc_type_name}
                    </Col>  
                    <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                    <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid green'}}>
                        <ClientCheck kh_id={info.ddzc_price} kh_name={info.ddzc_num} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col> 
                    {/* 第二行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 日期</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {info.ddzc_date}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {formatCurrency(info.ddzc_amount)}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                    <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid green'}}>
                        {info.ddzc_bm_name}
                    </Col>
                    {/* 第三行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 付款客户</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <ClientCheck kh_id={info.ddzc_kh_id} kh_name={info.ddzc_kh_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                    <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid green'}}>
                        {info.ddzc_khyhzh_name}
                    </Col>
                    {/* 第四行       */}
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 往来类型</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {info.ddzc_zflx}
                    </Col>                                   
                    <Col span={2} className={classes.col_middle_label}>备注</Col>
                    <Col span={6}  className={classes.col_middle_input}><Copy title={info.ddzc_content} /></Col>  
                    <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid green'}}>
                        {info.ddzc_qyyhzh_date} <AccountCheck qyyhzh_id={info.ddzc_qyyhzh_id} name={info.ddzc_qyyhzh_name} />
                    </Col>                                   
                    {/* 第五行       */}
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}>编号/状态</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                    {props.ddzc_id}&emsp;<StateTag state={info.ddzc_state} />
                    </Col>                                   
                    <Col span={2} className={classes.col_middle_label}>附件</Col>
                    <Col span={14}  className={classes.col_bottom_input} style={{borderRight:'3px solid green'}}>
                    <FilePreview 
                            fileNames={info.ddzc_image_file} 
                            fileUrls={info.ddzc_image_name} 
                        />
                    </Col>   
                    {/* 第六行 */}
                    <Col span={24} className={classes.bottom_row}>
                        <CostNodeCheck 
                            ddzc_id={props.ddzc_id} 
                            qy_id={props.qy_id} 
                            user_id={props.yh_id} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name} 
                            qy_name={props.qy_name}
                            ddzc_uname={info.ddzc_uname}
                            ddzc_ctime={info.ddzc_ctime}
                            ddzc_state_time={info.ddzc_state_time}
                        />
                    </Col>
                </Row> 
                <Row>
                    <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                        <DocumentRule/>
                        {(props.yh_id === props.ddzc_uid && props.ddzc_state ==='4') ? <Icon type='withdraw' onClick={() => {
                                                                                                // 如果正在提交中，直接返回
                                                                                                if (isSubmitting) {
                                                                                                    return;
                                                                                                }
                                                                                                
                                                                                                // 设置提交状态
                                                                                                setIsSubmitting(true);                                                                                                
                                                                                                ztxg({
                                                                                                    ddzc_id:props.ddzc_id,
                                                                                                    ddzc_state: '1',
                                                                                                }).then((res) => {
                                                                                                    if(res.data.Status === 'success') {
                                                                                                        message.success('团队报账单取消提交成功！')
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }else{
                                                                                                        message.error('团队报账单取消提交失败！'+res.data.Message)
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }
                                                                                                    // 3秒后恢复可点击状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                }).catch((err) => {
                                                                                                    // 出错时也要恢复状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                })
                                                                                            }} /> : null}
                        {yh_qx.includes('管理') ? <Space size={20}>
                            <CostFinanceWithdraw ddzc_id={props.ddzc_id} ddzc_cw_content={info.ddzc_cw_content} ddzc_amount={info.ddzc_amount}/>
                            <CostFinanceAmount ddzc_id={props.ddzc_id} ddzc_state={info.ddzc_state} ddzc_cw_content={info.ddzc_cw_content} ddzc_amount={info.ddzc_amount} />
                            <CostFinanceZFLX ddzc_id={props.ddzc_id} ddzc_zflx={info.ddzc_zflx} />
                        </Space> : null}
                    </Col>
                </Row>
                </div>
            </Modal>
        </>
    )
}

export default CostCheck